import React, {
  useState
} from "react";
import MarketingDocGate from "../MarketingDocGate";
import { eventNameError, urlError } from "../../utils/validation";

import {
  FormField,
  PageHeader,
  Select
} from "../components/Shared";


function ActionLink({ initial: stored = {}, onSave }) {

  const [action, setAction] = useState(stored.action || "URL");

  const [url, setUrl] =
    useState(stored.url || "https://example.com");

  const [target, setTarget] =
    useState(stored.target || "_blank");

  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');
  const [trackClick, setTrackClick] = useState(true);
  const [eventName, setEventName] = useState('cta_clicked');


  const save = async () => {
    setError('');
    const urlProblem = action === 'URL' ? urlError(url, { required: true, label: 'Destination URL' }) : '';
    if (urlProblem) { setError(urlProblem); return; }
    const eventProblem = action === 'EVENT' ? eventNameError(eventName) : '';
    if (eventProblem) { setError(eventProblem); return; }
    try {
      await onSave({ action, url, target, trackClick, eventName });
      window.dispatchEvent(new CustomEvent('chatbizz_cta_action_updated'));
      setSaved(true); setTimeout(() => setSaved(false), 1800);
    } catch (saveError) {
      setError(saveError.message || 'Unable to save the action.');
    }
  };


  return (
    <>

      <PageHeader
        eyebrow="MARKETING / CTA"
        title="CTA action & link"
        description="Configure what happens after a visitor clicks a CTA."
        action="Save configuration"
        onAction={save}
      />


      {error && <div className="alert alert-danger" role="alert">{error}</div>}

      {saved && (

        <div className="toast-inline">

          <i className="bi bi-check-circle-fill"></i>

          Action configuration saved

        </div>

      )}


      <div className="split-layout">

        {/* ACTION */}

        <div className="form-card">

          <div className="section-heading">

            <h3>
              Action
            </h3>

            <p>
              Choose the behavior associated with this CTA.
            </p>

          </div>


          <FormField label="Action type">

            <Select
              value={action}
              onChange={(e) =>
                setAction(e.target.value)
              }
            >

              <option value="URL">
                Open URL
              </option>

              <option value="FORM">
                Open form
              </option>

              <option value="CHAT">
                Start conversation
              </option>

              <option value="EVENT">
                Trigger custom event
              </option>

            </Select>

          </FormField>


          {action === "URL" && (

            <>

              <FormField label="Destination URL">

                <input
                  className="form-control"
                  value={url}
                  onChange={(e) =>
                    setUrl(e.target.value)
                  }
                />

              </FormField>


              <FormField label="Open link">

                <Select
                  value={target}
                  onChange={(e) =>
                    setTarget(e.target.value)
                  }
                >

                  <option value="_blank">
                    New tab
                  </option>

                  <option value="_self">
                    Same tab
                  </option>

                </Select>

              </FormField>


              <div className="setting-row">

                <div>

                  <strong>
                    Track click
                  </strong>

                  <small>
                    Send a CTA click event to conversion tracking.
                  </small>

                </div>

                <input className="form-check-input" type="checkbox" checked={trackClick} onChange={(e) => setTrackClick(e.target.checked)} />

              </div>

            </>

          )}


          {action === "FORM" && (

            <FormField label="Form">

              <Select>

                <option>
                  Demo request form
                </option>

                <option>
                  Contact sales form
                </option>

              </Select>

            </FormField>

          )}


          {action === "EVENT" && (

            <FormField label="Event name">

              <input className="form-control" value={eventName} onChange={(e) => setEventName(e.target.value)} placeholder="cta_clicked" />

            </FormField>

          )}


          <div className="info-box">

            <i className="bi bi-info-circle"></i>

            <div>

              <strong>
                Validation
              </strong>

              <p>
                URLs must use http:// or
                https://. Custom event names can
                contain letters, numbers,
                underscores and hyphens.
              </p>

            </div>

          </div>

        </div>


        {/* PREVIEW */}

        <div className="form-card">

          <div className="section-heading">

            <h3>
              Preview
            </h3>

            <p>
              Review the configured CTA action before publishing.
            </p>

          </div>


          <div className="action-preview">

            <div className="mini-browser">

              <div className="browser-bar">

                <span></span>
                <span></span>
                <span></span>

              </div>


              <div className="browser-body">

                <div className="fake-title">
                  Ready to talk?
                </div>


                <button className="preview-cta">

                  Book a demo

                  <i className="bi bi-arrow-up-right ms-2"></i>

                </button>


                <small>

                  Click behavior:{" "}

                  {action === "URL"
                    ? "Open destination URL"
                    : action === "FORM"
                    ? "Open selected form"
                    : action === "CHAT"
                    ? "Start conversation"
                    : "Trigger custom event"}

                </small>

              </div>

            </div>

          </div>

        </div>

      </div>

    </>
  );
}

export default function ActionLinkPage() {
  return <MarketingDocGate section="action">{({ doc, save }) => <ActionLink initial={doc} onSave={save} />}</MarketingDocGate>;
}
